import { Button } from '@/interfaces/button';
import { ButtonResource, buttonResource } from '@/resources/button.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł przycisków
 *
 * @export
 * @class ButtonModule
 * @extends {EntityModule<Button, ButtonResource>}
 */
export class ButtonModule extends EntityModule<Button, ButtonResource> {
  constructor() {
    super(buttonResource);
    const superList = this.actions.list;

    this.actions = {
      ...this.actions,

      /**
       * Lista przycisków
       *
       * @param {*} context
       * @param {*} variables
       * @returns {Promise<any>}
       */
      list: (context: any, variables: any): Promise<any> =>
        superList(context, {
          orderBy: [
            { name: 'order', desc: false },
            { name: 'id', desc: true }
          ],
          ...variables
        }),

      /**
       *  Użycie przycisku
       *
       * @param {*} context
       * @param {object} variables
       * @returns {Promise<any>}
       */
      use: (context: any, variables: object): Promise<any> => this.resource.use(variables),

      /**
       * Użycie przycisku dla wielu encji jednocześnie w pojedynczej transakcji
       *
       * @param {*} context
       * @param {*} variables
       * @returns {Promise<any>}
       */
      useMultiple: (context: any, variables: any): Promise<any> => this.resource.useMultiple(variables),

      /**
       * Użycie przycisku dla wielu encji jednocześnie w osobnych transakcjach
       *
       * @param {*} context
       * @param {*} variables
       * @returns {Promise<any>}
       */
      useMultipleWithoutTransaction: (context: any, variables: any): Promise<any> =>
        this.resource.useMultipleWithoutTransaction(variables)
    };
  }
}

export default new ButtonModule();
